import React from "react";
import {Card, CardContent, List, Typography} from "@mui/material";
import {DueChartProps} from "../../../../entity/props/chart/due-chart-props";
import Grid from "@mui/material/Grid2"
import {ChartStatus} from "../../../../entity/resource/chart-status";
import {ChartTitle} from "../../../../entity/enums/chart-title";
import Box from "@mui/material/Box";

import '../../../../assets/css/style.css';
import '../../../../assets/css/chart/due-chart.css';

const DueChart = (props: DueChartProps): JSX.Element => {

    const chartSize = 17;

    const renderChartTitle = (chartStatus: ChartStatus): JSX.Element => {
        return (
          <Box className={'chart-title-list-item-container'}>
              <span id={`${chartStatus.status}-count`} className={'chart-title-list-item count'}>{chartStatus.count < 10 ? chartStatus.count + ' ' : chartStatus.count}</span>
              <span id={`${chartStatus.status}`} className={'chart-title-list-item status'}>{chartStatus.status}</span>
              <hr className={
                  chartStatus.status === ChartTitle.PAST_DUE
                    ? 'inline-hr past-due'
                    : chartStatus.status === ChartTitle.TODAY_DUE
                          ? 'inline-hr today-due'
                          : chartStatus.status === ChartTitle.DUE_THIS_WEEK
                                ? 'inline-hr this-week-due'
                                : chartStatus.status === ChartTitle.DUE_NEXT_WEEK
                                    ? 'inline-hr next-week-due'
                                    : 'inline-hr this-month-due'
              }/>
          </Box>
        );
    }

    const renderChartData = (chartStatus: ChartStatus): JSX.Element => {
        return (
            <Box key={chartStatus.status} className={'chart-bar-ui-item-wrapper'}>
                <Box className={'chart-bar-ui-item'}>
                    {
                        Array.from({ length: Math.min(chartStatus.count, chartSize) }).map((_: unknown, i: number): JSX.Element => (
                            <Box
                                key={i}
                                onClick={(): void => props.setChartTitle(chartStatus.status)}
                                className={
                                    (chartStatus.status === ChartTitle.PAST_DUE || chartStatus.status === ChartTitle.TODAY_DUE)
                                        ? 'chart-bar-item-block due'
                                        : 'chart-bar-item-block not-due'}/>
                        ))
                    }
                    {
                        chartStatus.count > chartSize &&
                            <Box display={'flex'}>
                                ...
                                <Box className={'chart-bar-item-text'}>+{chartStatus.count - chartSize}</Box>
                            </Box>
                    }
                </Box>
            </Box>
        );
    }

    return (
        <Card elevation={0} className='chart-card'>
            <CardContent className='chart-card-content'>
                <Grid container direction='column'>
                    <Grid>
                        <Typography variant={'h5'} className={'chart-title'}>Files By Due Date</Typography>
                    </Grid>
                    <Grid>
                        <List className={'chart-title-list'}>
                            {
                                props.data?.map(renderChartTitle)
                            }
                        </List>
                    </Grid>
                </Grid>
                <Box className={'chart-bar-ui'}>
                    {
                        props.data.map(renderChartData)
                    }
                </Box>
            </CardContent>
        </Card>
    );
}

export default DueChart;


